import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5f998c5b"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "card-header"
  }, [/*#__PURE__*/_createElementVNode("h2", null, "✨ 朝旭行知录 ✨")], -1);
});

var _hoisted_2 = {
  class: "card-body"
};
var _hoisted_3 = {
  class: "title"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("表单内容");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_card = _resolveComponent("el-card");

  return _openBlock(), _createBlock(_component_el_card, {
    class: "box-card"
  }, {
    header: _withCtx(function () {
      return [_hoisted_1];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString($props.title), 1), _renderSlot(_ctx.$slots, "default", {}, function () {
        return [_hoisted_4];
      }, true)])];
    }),
    _: 3
  });
}